module.exports = __webpack_public_path__ + "img/record-empty.f71062bb.png";